export default "__VITE_ASSET__8C0b5AjF__"